module.exports = __webpack_public_path__ + "img/0S6A9774.3f2e38e1.jpg";